import type { HolePlan } from './courseAuthoring';

export function plans(
  names: string[],
  pars: number[],
  yards: number[],
  options: Partial<HolePlan>[] = [],
): HolePlan[] {
  const headings = [
    0.12, 0.72, 1.42, 2.38, 3.02, -2.45, -1.3, -0.55, 0.28, 1.1, 2.05, 2.82, -2.82, -1.92, -0.92,
    -0.12, 0.88, 1.72,
  ];
  return pars.map((par, i) => ({
    par,
    yardage: yards[i],
    name: names[i] ?? `Hole ${i + 1}`,
    heading: headings[i],
    dogleg: par === 3 ? 'none' : i % 3 === 0 ? 'right' : i % 3 === 1 ? 'left' : 'none',
    elevation: { tee: 0, landing: ((i % 3) - 1) * 3, green: ((i % 4) - 1) * 2 },
    landingZones: [
      {
        distance: Math.min(285, yards[i] * 0.55),
        width: par === 3 ? 25 : 40,
        preferredSide: i % 2 ? 'right' : 'left',
      },
    ],
    bunkerCount: par === 3 ? 2 : 3,
    ...options[i],
  }));
}
